<template>
  <div class="campus-faq">
    <h2>招聘FAQ</h2>
    <div class="hr">
      <p><span>Q：</span>网申截止时间是什么时候？一定需要网申吗？</p>
      <p><span>A：</span>职位招满即截止接收简历，请同学们务必要网申，建议尽早提交简历，以免错过。</p>
      <p><span>Q：</span>每人最多可以投递几个岗位？</p>
      <p><span>A：</span>每人最多只能选择一个岗位进行投递简历。</p>
      <p><span>Q：</span>什么时候笔试？是线上笔试还是现场笔试？所有岗位都需要笔试吗？</p>
      <p><span>A：</span>校招岗位宣讲会之后即进行现场笔试。</p>
      <p><span>Q：</span>什么岗位需要提交作品？提交到哪？</p>
      <p><span>A：</span>岗位介绍有注明是否需要提交作品，建议作品链接附在个人简历中，或是与简历发至邮箱 <a href="mailto:ybzp@youban.org">ybzp@youban.org</a>，需备注姓名+学校+应聘岗位。</p>
      <p><span>Q：</span>笔试通过，面试有几轮？</p>
      <p><span>A：</span>笔试通过后一般会在3天内通知面试，面试分为初试和复试，一般是2~3轮。</p>
      <p><span>Q：</span>面试通知采用什么形式？</p>
      <p><span>A：</span>校招过程中会通过短信、电话或邮件中的一种联系方式联系，请保证邮箱及电话填写正确，同时保持通讯畅通。</p>
      <p><span>Q：</span>公司提供实习机会吗？</p>
      <p><span>A：</span>为了让校招生提前了解公司和熟悉工作环境，原则上要求校招生在合适的时间参加统一安排的培训和实习，实习期间提供实习补贴。</p>
      <p><span>Q：</span>公司的办公地点？</p>
      <p><span>A：</span>深圳总部：深圳市南山区深南大道10168号佳嘉豪商务大厦12楼；<br><span style="padding-left: 30px;font-weight:normal;">广州分公司：广州市番禺区钟村街钟汉路22号、24号二楼203-9。</span></p>
    </div>
  </div>
</template>
<script>
export default {
  name: "CampusFaq"
};
</script>
<style scoped>
.campus-faq {
  font-size: 18px;
  color: #333;
}
.campus-faq h2 {
  height: 75px;
  width: 100%;
  font-size: 40px;
  text-align: center;
  color: #484747;
  font-weight: normal;
}
.campus-faq .hr p {
  font-size: 18px;
  margin-bottom: 8px;
}
.campus-faq .hr p:nth-of-type(2n) {
  margin-bottom: 50px;
}
.campus-faq .hr p:first-child {
  margin-top: 30px;
}
.campus-faq .hr p span {
  font-weight: bold;
}
</style>


